"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _333fmIcon = createIcon({
  displayName: "_333fmIcon",
  viewBox: "0 0 500 500",
  path: (
    <>
      <path
        d="m233.65 349.13c28.964-79.663 57.749-158.833 86.686-238.421 39.981.633 75.703 13.602 106.74 38.845-28.854 79.365-57.585 158.397-86.531 238.013-32.38-21.474-68.053-34.377-106.895-38.437z"
        fill="currentColor"
      />
      <path
        d="m330.838 80.083c4.42-12.027 8.563-23.458 12.878-34.826.492-1.296 1.739-2.749 2.988-3.244 13.553-5.377 27.471-9.129 42.2-9.437 20.949-.437 35.875 10.381 48.05 25.878 5.233 6.663 9.434 14.146 13.986 21.33.604.951 1.014 2.52.665 3.501-4.166 11.724-8.492 23.391-12.912 35.446-32.797-21.733-68.405-34.528-107.855-38.648z"
        fill="currentColor"
      />
      <path
        d="m251.47 466.013c-.836-1.796-1.426-3.058-2.015-4.322-10.146-21.757-20.293-43.514-30.436-65.271-1.477-3.171.235-13.635 2.837-15.838.808-.685 2.329-.77 3.512-.734 37.824 1.162 71.613 13.455 101.417 36.785 2.047 1.602 2.333 2.969 1.693 5.562-1.72 6.972-5.656 10.951-12.381 13.901-21.527 9.446-42.704 19.694-64.627 29.917z"
        fill="currentColor"
      />
      <path d="m71.597 62.5h100v100h-100z" fill="currentColor" />
      <path d="m72.097 202.5h100v100h-100z" fill="currentColor" />
      <path d="m72.347 342.5h100v100h-100z" fill="currentColor" />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default _333fmIcon;
